import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Check, ArrowLeft, Soup } from "lucide-react";
import { toast } from "sonner";
import { castVote } from "../lib/api";

export default function VotePage() {
  const { soup } = useParams();
  const soupName = decodeURIComponent(soup || "");
  const [name, setName] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || busy) return;
    setBusy(true);
    try {
      await castVote({ name: name.trim(), soup: soupName });
      setDone(true);
    } catch {
      toast.error("Couldn't cast your vote — try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#A3B18A] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md border-2 border-forest bg-moss p-8 md:p-10 shadow-[8px_8px_0_0_#140C06]" data-testid="vote-page">
        {done ? (
          <div className="text-center" data-testid="vote-success">
            <div className="mx-auto mb-6 h-14 w-14 rounded-full bg-ember flex items-center justify-center">
              <Check className="text-[#FBF4E8]" size={26} />
            </div>
            <h1 className="font-display text-3xl text-cream">Vote counted!</h1>
            <p className="font-accent text-3xl text-ember mt-3 -rotate-1">may the best soup win</p>
            <Link
              to="/"
              data-testid="vote-back-link"
              className="mt-8 inline-flex items-center gap-2 font-body text-xs uppercase tracking-[0.25em] text-fog hover:text-ember transition-colors duration-300"
            >
              <ArrowLeft size={14} /> Back to the party page
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="vote-form">
            <div className="flex items-center gap-2 mb-5">
              <Soup className="text-ember" size={20} />
              <p className="font-body text-[11px] uppercase tracking-[0.3em] text-fog">Tasting Ballot</p>
            </div>
            <p className="font-accent text-3xl text-forest -rotate-1">you're voting for</p>
            <h1 className="font-display italic text-3xl md:text-4xl text-ember leading-tight mt-1" data-testid="vote-soup-name">
              {soupName}
            </h1>
            <div className="mt-8">
              <label className="field-label" htmlFor="vote-name">Your Name</label>
              <input
                id="vote-name"
                data-testid="vote-name-input"
                className="field"
                placeholder="One vote per person"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <p className="mt-2 font-body text-xs text-fog/70">Changed your mind? Scan another pot and vote again — your vote moves with you.</p>
            </div>
            <button
              data-testid="vote-submit-btn"
              type="submit"
              disabled={!name.trim() || busy}
              className="btn-ember w-full mt-8 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              {busy ? "Casting…" : "Cast My Vote"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
